import React, { createContext, useMemo, useContext } from 'react';

let LocalSectionContext = createContext(null);

export function LocalSectionProvider({ title, id = '', children, sectionRef }) {
  let contextValue = useMemo(() => ({ sectionMeta: { id, title }, sectionRef }), [id, sectionRef, title]);

  return <LocalSectionContext.Provider value={contextValue}>{children}</LocalSectionContext.Provider>;
}

export function useLocalSection() {
  return useContext(LocalSectionContext);
}
